@if (callNoteResponse$ | async; as callNoteResponse) {
	<div [ngClass]="{ expanded: isExpanded() }" class="wrapper cft-border">
		<!-- Print-only header (hidden on screen, visible in @media print) -->
		<div class="print-header no-screen">
			<div class="print-header__row">
				<mat-icon [svgIcon]="ICONS.LOGO" class="print-logo"></mat-icon>
				<span class="print-heading">{{ I18N.CALL_LABEL | i18n | async }}</span>
			</div>
			<div class="print-separator"></div>
		</div>

		<div class="title">{{ callNoteResponse.callbackOnCallNoteDTO.callNote.subject }}</div>
		<div class="separator"></div>

		<!-- call details -->
		<div class="detail-wrapper">
			<div class="call-detail">
				@if (callNoteResponse.localProcessingDate) {
					<div class="date-time">
						{{ callNoteResponse.localProcessingDate | date: 'MMM d, y, HH:mm' }}
					</div>
				}

				<div class="caller">
					{{ callNoteResponse.callbackOnCallNoteDTO.callNote.caller.salutation }}
					{{ callNoteResponse.callbackOnCallNoteDTO.callNote.caller.firstname }}
					{{ callNoteResponse.callbackOnCallNoteDTO.callNote.caller.lastname }}
				</div>
			</div>
			<button (click)="toggleView()" class="expand-button no-print" matIconButton="outlined">
				<mat-icon class="material-symbols-outlined">keyboard_arrow_up</mat-icon>
			</button>
		</div>

		<!-- ./call details -->

		<!-- call note-->
		@if (callNoteResponse.callbackOnCallNoteDTO.callNote.message; as message) {
			<div class="message">
				{{ message }}
			</div>
		}
		<!-- ./call note-->

		<!-- form fields and their values -->
		<div class="expandable-content">
			<div class="caller-numbers">{{ I18N.CALLER_NUMBERS | i18n | async }}</div>
			<div class="phone-numbers">
				@for (
					phone of callNoteResponse.callbackOnCallNoteDTO.callNote.caller.telephoneNumbers;
					track phone.number
				) {
					<span>{{ phone.number }}</span>
				}
			</div>

			@if (callNoteResponse.callbackOnCallNoteDTO.callNote.formfieldValues.length) {
				<app-form-field-list
					[fields]="callNoteResponse.callbackOnCallNoteDTO.callNote.formfieldValues"
				></app-form-field-list>
			}
		</div>

		<!-- ./form fields and their values -->
	</div>

}
